import { connect } from 'react-redux';
import type { AppState } from 'state/state.model';
import * as TradeAllocationSelectors from 'state/tradeAllocationForm/tradeAllocationForm.selector';

interface OwnProps {
  tabId: string;
}

interface StateProps {
  startingTimeInMillis: number;
  durationTimeInMillis: number;
}

export type InitializedStatusProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  return {
    startingTimeInMillis: TradeAllocationSelectors.getApplyRequestStartingTimeMs(state, tabId)!,
    durationTimeInMillis: TradeAllocationSelectors.getApplyRequestEstimatedDurationTimeInMs(state, tabId)!,
  };
};

export const connectPendingStatus = connect(mapStateToProps);
